const projects = [
  {
    image: '/project_image/sollyverse.png',
    name: 'Sollyverse',
    description:
      'A Travel website users can use to make reservations to tour their favourite cities. Users can create an account, sign up, make reservations and like a city or country an leave review.',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      },
      {
        name: 'Express.js',
        logo: '/technologies/express.png',
        color: 'cyan'
      },
      {
        name: 'MongoDB',
        logo: '/technologies/mongodb.svg',
        color: 'yellow'
      },
      {
        name: 'Supabase',
        logo: '/technologies/supabase.svg',
        color: 'yellow'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/sollyverse-travels',
        title: 'Front-End Source'
      },
      {
        source: 'https://github.com/Solobarine/sollyverse-backend',
        title: 'Back-End Source'
      },
      {
        live: 'https://sollyverse.netlify.com',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/continental.png',
    name: 'Continental',
    description:
      '"Continental" is a Vue.js app for secure money management. It provides form validation, routing, and Pinia for state management. Features include real-time updates for deposits, easy fund transfers, and unique account numbers upon registration.',
    languages: [
      {
        name: 'TypeScript',
        logo: '/technologies/typescript.svg'
      },
      {
        name: 'PHP',
        logo: '/technologies/php.svg'
      },
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'Vue',
        logo: '/technologies/vue.svg',
        color: 'lime'
      },
      {
        name: 'Laravel',
        logo: '/technologies/laravel.svg',
        color: 'cyan'
      },
      {
        name: 'MySQL',
        logo: '/technologies/mysql.svg',
        color: 'yellow'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/continental',
        title: 'Front-End Source'
      },
      {
        source: 'https://github.com/Solobarine/continental_backend',
        title: 'Back-End Source'
      },
      {
        live: 'https://continental-kappa.vercel.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/correo.png',
    name: 'Correo',
    description:
      'Correo is a Social Media Application which allows users make posts, view posts from other users, like and comment posts and delete their own posts.',
    languages: [
      {
        name: 'PHP',
        logo: '/technologies/php.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'Laravel',
        logo: '/technologies/laravel.svg',
        color: 'lime'
      },
      {
        name: 'TailwindCSS',
        logo: '/technologies/tailwind.svg',
        color: 'cyan'
      },
      {
        name: 'PostgreSQL',
        logo: '/technologies/postgre.png',
        color: 'yellow'
      },
      {
        name: 'MailTrap',
        logo: '/technologies/mailtrap.png',
        color: 'green'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/correo',
        title: 'Source'
      }
    ]
  },
  {
    image: '/project_image/go_buddy.png',
    name: 'Go Buddy',
    description:
      'Go Buddy is a simple Task Management Application. Users can Create Tasks, Update Tasks and Mark Task as in progress or as completed. A Summary of all tasks is shown on the Dashoard.',
    languages: [
      {
        name: 'TypeScript',
        logo: '/technologies/typescript.svg'
      },
      {
        name: 'CSS Modules',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      },
      {
        name: 'Redux',
        logo: '/technologies/redux.png',
        color: 'gold'
      },
      {
        name: 'Supabase',
        logo: '/technologies/supabase.svg',
        color: 'green'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/go_buddy',
        title: 'Source'
      }
    ]
  },
  {
    image: '/project_image/space-hub.JPG',
    name: "Space Traveller' Hub",
    description:
      'This website used The Space-X APi. It allows users make reservations on missions, rockets and dragons. Users can also view all avaliable missions, rockets and dragons. They can as well see the reservations they made.',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Front End',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      },
      {
        name: 'Redux',
        logo: '/technologies/redux.png',
        color: 'red'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/Space-Travellers-Hub',
        title: 'Source'
      },
      {
        live: 'https://msd-space-travellers.netlify.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/free-games.JPG',
    name: 'Free Games',
    description:
      'This site shows users the list of free games avaliable. Users also have the ability to like or comment on the game and make reservations. Users can also see the comments and reservations of other users.',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Front End',
    tech: [],
    status: 'Completed',
    links: [
      {
        source: 'https://solobarine/Free-Games',
        title: 'Source'
      },
      {
        live: 'https://rms-free-games.netlify.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/dart.jpg',
    name: 'Dart',
    description:
      'This is a financial services website. Users can deposit funds, send and receive money to and from fellow users only when they create an account.',
    languages: [
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      },
      {
        name: 'PHP',
        logo: '/technologies/php.svg'
      },
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'Vue',
        logo: '/technologies/vue.svg',
        color: 'lime'
      },
      {
        name: 'Laravel',
        logo: '/technologies/laravel.svg',
        color: 'cyan'
      },
      {
        name: 'MySQL',
        logo: '/technologies/mysql.svg',
        color: 'yellow'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/dart-f',
        title: 'Front-End Source'
      },
      {
        source: 'https://github.com/Solobarine/dart',
        title: 'Back-End Source'
      },
      {
        live: 'https://dart-three.vercel.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/my_nba.PNG',
    name: 'My NBA',
    description:
      "The My NBA App offers quick access to key details about all NBA teams, including Team History, Jersey, Stadium. It's your one-stop source for staying informed about your favorite teams.",
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'TypeScript',
        logo: '/technologies/typescript.svg'
      }
    ],
    stack: 'Front End',
    tech: [
      {
        name: 'Next.js',
        logo: '/technologies/next.svg',
        color: 'lime'
      },
      {
        name: 'CSS Modules',
        logo: '/technologies/css.svg',
        color: 'orange'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/my_nba',
        title: 'Source'
      },
      {
        live: 'https://my-nba-three.vercel.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/calculator.PNG',
    name: 'Math Magicians',
    description:
      'A Simple Calculator useful for solving basic Arithemetic problems like Addition, Subtraction, Multiplication and Division.',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Front End',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/math-magicians',
        title: 'Source'
      },
      {
        live: 'https://solly-math-magicians.netlify.com',
        title: 'Live'
      }
    ]
  },
  {
    image: '/project_image/leaderboard.PNG',
    name: 'Leaderboard',
    description:
      'Users can use the Leaderboard website to save highscores along with their name and also view all the scores previously entered. ',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Front End',
    tech: [],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/leaderboard',
        title: 'Source'
      },
      {
        live: 'https://leaderboard-solly.netlify.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/book-store.JPG',
    name: 'Bookstore',
    description:
      'A website that makes organizing your books easy for you. You can catalog your favourite books and store them using the local storage of the browser.',
    languages: [
      {
        name: 'HTML',
        logo: '/technologies/html.svg'
      },
      {
        name: 'CSS',
        logo: '/technologies/css.svg'
      },
      {
        name: 'JavaScript',
        logo: '/technologies/js.png'
      }
    ],
    stack: 'Front End',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/book-store',
        title: 'Source'
      },
      {
        live: 'https://bookstore-solly.vercel.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/nova.png',
    name: 'Nova',
    description:
      'A Series Website where you can find your favourite series. It features functionalities like User Auth, Persisted Login, Pagination and many more',
    languages: [
      {
        name: 'TypeScript',
        logo: '/technologies/typescript.svg'
      },
      {
        name: 'PHP',
        logo: '/technologies/php.svg'
      }
    ],
    stack: 'Full Stack',
    tech: [
      {
        name: 'React',
        logo: '/technologies/react.png',
        color: 'lime'
      },
      {
        name: 'Laravel',
        logo: '/technologies/laravel.svg',
        color: 'gold'
      }
    ],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/nova',
        title: 'Front End Source'
      },
      {
        source: 'https://github.com/solobarine/nova_backend',
        title: 'Back End Source'
      },
      {
        live: 'https://nova-solobarine.vercel.app',
        title: 'Live Website'
      }
    ]
  },
  {
    image: '/project_image/ruby.png',
    name: 'School Library',
    description: 'A commabd-line app which lets users register themselves, create a book and reserve a book.',
    languages: [{ name: 'Ruby', logo: '/technologies/ruby.svg' }],
    stack: 'Command Line',
    tech: [],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/solobarine/School-Library',
        title: 'Source'
      }
    ]
  },
  {
    image: '/project_image/ruby.png',
    name: 'Catalog',
    description:
      'This command line app built with Ruby can serve as an organizer. It enables users sort their properties into categories.',
    languages: [{ name: 'Ruby', logo: '/technologies/ruby.svg' }],
    stack: 'Command Line',
    tech: [],
    status: 'Completed',
    links: [
      {
        source: 'https://github.com/Solobarine/Catalog',
        title: 'Source'
      }
    ]
  }
];

export default projects;
